import {BitmapText} from "pixi.js";
import {Power3, TimelineMax, TweenMax} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {CurrencyOptions} from "@nolimitcity/slot-launcher/bin/interfaces/APICurrency";
import {Helper} from "../../core/utils/Helper";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TheRaveSound} from "../sound/TheRaveSound";

export interface BitmapTextStyleOptions {
    fontName: string;
    fontSize: number;
    align?: string;
    tint?: number;
    letterSpacing?: number;
    maxWidth?: number;
}

export interface ICountUpAnimationConfig {
    duration: number;
    ease?: any;
    withoutSound?: boolean;
    onStart?: Function;
    onUpdate?: Function;
    onComplete?: Function;
}

export class BitmapCountUp extends BitmapText {

    private _currencyOption: CurrencyOptions | undefined;
    private _currentValue: number;

    private _maxTextWidth: number;
    private counterTl: TimelineMax;

    get maxTextWidth(): number {
        return this._maxTextWidth;
    }

    set maxTextWidth(value: number) {
        this._maxTextWidth = value;
        if (this.parent) {
            this.updateCountUpTextPivot();
        }
    }

    get currentValue(): number {
        return this._currentValue;
    }

    set currentValue(value: number) {
        this._currentValue = value;
        this.onCountUpUpdate();
    }

    get scaling(): number {
        return this.scale.x;
    }

    set scaling(value: number) {
        this.scale.set(value);
    }

    constructor(config: BitmapTextStyleOptions, currencyOption?: CurrencyOptions, name?:string) {
        super(".", config);
        this.name = name!;
        this._currencyOption = currencyOption;
    }

    public getCountUpAnimation(fromValue: number, toValue: number, animationConfig: ICountUpAnimationConfig): TimelineMax {
        this.counterTl = Helper.setTimelineMax(this.counterTl, new TimelineMax({
            onStart: () => Helper.triggerIfExist(animationConfig.onStart),
            onUpdate: () => Helper.triggerIfExist(animationConfig.onUpdate),
            onComplete: () => Helper.triggerIfExist(animationConfig.onComplete),
        }), true);
        const noSound:boolean =  animationConfig.withoutSound ? animationConfig.withoutSound:false;
        if(animationConfig.duration>0.01 && !noSound){
            this.counterTl.add(()=>{TheRaveSound.playSoundEffect("countup", 50)});
        }
        this.counterTl.fromTo(this, {currentValue: fromValue},
            {
                duration: animationConfig.duration,
                currentValue: toValue,
                ease: animationConfig.ease ? animationConfig.ease : Power3.easeInOut,
            }
        );
        if(animationConfig.duration>0.01 && !noSound) {
            this.counterTl.add(() => {
                TheRaveSound.stopSoundEffect("countup")
            });
        }
        return this.counterTl;
    }

    public getBwCountUpAnimation(fromValue: number, toValue: number, animationConfig: ICountUpAnimationConfig): TimelineMax {
        this.counterTl = Helper.setTimelineMax(this.counterTl, new TimelineMax({
            onStart: () => Helper.triggerIfExist(animationConfig.onStart),
            onUpdate: () => Helper.triggerIfExist(animationConfig.onUpdate),
            onComplete: () => Helper.triggerIfExist(animationConfig.onComplete),
        }), true);
        const noSound:boolean =  animationConfig.withoutSound ? animationConfig.withoutSound:false;
        if(animationConfig.duration>0.01 && !noSound){
            this.counterTl.add(()=>{TheRaveSound.playSoundEffect("countup", 50)});
        }
        this.counterTl.fromTo(this, {currentValue: fromValue},
            {
                duration: animationConfig.duration,
                currentValue: toValue
            }
        );
        //this.counterTl.add([
            /*TweenMax.to(this, 0.15, {
                fontSize: this.fontSize + 34,
                yoyo: true
            }),*/
            //()=>{TheRaveSound.stopSoundEffect("countup")}
        //]);
        //his.counterTl.add(() => {}, "+=0.3");
        return this.counterTl;
    }

    public setTextStyle(config: BitmapTextStyleOptions): boolean {

        if (this.fontName === config.fontName) return false;

        this.fontName = config.fontName;
        this.fontSize = config.fontSize;
        this.letterSpacing = config.letterSpacing!;

        return true;
    }

    public showValue(value: number, formate: boolean = true): void {
        this.currentValue = formate ? parseFloat(SlotGame.apiPlugin.currency.formatValue(value, this._currencyOption)) : value;
        this.text = formate ? SlotGame.apiPlugin.currency.formatValue(this.currentValue, this._currencyOption) : this.currentValue.toString()

        this.updateCountUpTextPivot();
    }

    private onCountUpUpdate(): void {
        this.text = SlotGame.apiPlugin.currency.formatValue(this.currentValue, this._currencyOption);
        this.updateCountUpTextPivot();
    }

    public updateCountUpTextPivot(): void {
        this.updateTransform();
        if (this.maxTextWidth == null || this.maxTextWidth <= 0) {
            this.maxTextWidth = NolimitApplication.screenBounds.width;
        }

        while (this.textWidth * this.scaling > this.maxTextWidth) {
            this.scaling = this.scaling * 0.995;
            this.updateTransform();
        }
    }
}